



































import Vue, { PropType } from 'vue';
import { ContractRenewalStateEnum, IContract } from '@/models';

export default Vue.extend({
  name: 'ContractRenewalStateDisplay',

  props: {
    contract: { type: Object as PropType<IContract>, required: true }
  },

  computed: {
    ContractRenewalStateEnum: () => ContractRenewalStateEnum,
    getRenewalStateColor(): string {
      return this.contract.getRenewalStateColor();
    },

    getRenewalStateMessage(): string {
      return this.contract.getRenewalStateMessage();
    }
  }
});
